module.exports = __webpack_public_path__ + "images/help_v2/icon-ppt-cbb5632fea13487700c10e9b65b1e86d.png";